var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ReactSelect from 'react-select';
import Label from '../Label';
var Select = function (_a) {
    var label = _a.label, props = __rest(_a, ["label"]);
    return _jsxs(_Fragment, { children: [_jsx(Label, { label: label }), _jsx(ReactSelect, __assign({}, props, { styles: {
                    option: function (base) { return (__assign(__assign({}, base), { minWidth: '200px' })); },
                    control: function (base) { return (__assign(__assign({}, base), { minWidth: '200px' })); },
                    menu: function (base) { return (__assign(__assign({}, base), { minWidth: '200px', zIndex: 100 })); },
                    container: function (base) { return (__assign(__assign({}, base), { marginBottom: '0.5rem' })); }
                }, classNamePrefix: "select" }))] });
};
export default Select;
